import { useEffect, useState } from 'react'

/** Evita desajustes de hidratación al renderizar UI que depende del cliente (OTP, autofill, etc.). */
export function useHasMounted(): boolean {
	const [mounted, setMounted] = useState(false)
	useEffect(() => setMounted(true), [])
	return mounted
}
